<template>
  <div>
    <v-dialog name="dialog" />
    <div class="admin_title">字典管理</div>
    <div class="gj_top_class">
      <input type="button" class="btn_s_gj" @click="search(filters)" />
      <input v-if="filtersType == '1'" type="text" class="put_gj" name="name" v-model="filters.value" @keyup.13="search(filters)" />
      <input v-if="filtersType == '2'" type="text" class="put_gj" name="name" v-model="filters.label" @keyup.13="search(filters)" />
      <input v-if="filtersType == '3'" type="text" class="put_gj" name="name" v-model="filters.type"  @keyup.13="search(filters)" />
      <select class="selcet_put" v-model="filtersType">
        <option value="1">按键值过滤</option>
        <option value="2">按标签过滤</option>
        <option value="3">按类型过滤</option>
      </select>
      <a @click="edit('')" class="btn btn_add">新增字典</a>
    </div>
    <div class="gj_list" style="min-height:670px;">
      <h5 class="none_ts" v-if="pages <= 0 || !tableData">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
      <BylTable v-bind:model="tableData"  v-if="pages > 0">
        <span slot="edit" @click="edit(props.item.id)" class="xo-table-btn" slot-scope="props">编辑</span>
        <span slot="del" @click="del(props.item)" class="xo-table-btn" slot-scope="props">删除</span>
      </BylTable>
    </div>
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt v-if="pages> 0">共{{cnt}}条记录</dt>
        <dd v-if="pages >0">
          <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text></paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import BylTable from '@/components/common/table/index.vue'
  import Paginate from 'vuejs-paginate'
  import { mapState } from 'vuex'
  export default {
    components: { Paginate, BylTable },
    mounted () {
      this.search(this.filters)
    },
    data () {
      return {
        lists: [],
        filters: {
          pageNo: 1,
          pageSize: 12
        },
        filtersType: '1',
        cnt: 0,
        pages: 0,
        prefix: this.$route.meta.prefix || '',
        tableData: {
          columns: [
            {
              field: 'value',
              title: '键值',
              colWidth: 82
            }, {
              field: 'label',
              title: '标签',
              colWidth: 240
            }, {
              field: 'type',
              title: '类型',
              colWidth: 122
            }, {
              field: 'sort',
              title: '排序',
              colWidth: 80
            }
          ],
          data: [],
          actions: ['edit', 'del']
        }
      }
    },
    computed: {
      ...mapState('orgstructure', ['menus'])
    },
    methods: {
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      edit (id) {
        if (id == '') {
          id = 'void'
        }
        this.$router.push({path: this.prefix + '/org/dict/'+ id})
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '删除',
          text: '确认删除吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      del (item) {
        if (item) {
          var that = this
          this.confirmBox({
            yes: function () {
              api.get(config.bylBaseCenterPath, '/dict/delete', {id: item.id}, function (r) { // 正常
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      search (filters) {
        if (!filters) { filters = {} }
        var that = this
        this.removeFiltersAttr(filters, this.filtersType) // 去除多余的过滤条件
        api.get(config.bylBaseCenterPath, '/dict/findList', filters, function (r) { // 正常
          that.pages = Math.ceil(r.cntData / that.filters.pageSize)
          that.tableData.data = r.data
          that.cnt = r.cntData
        })
      },
      removeFiltersAttr (filters, type) {
        switch (type) {
          case '1': {
            if (filters.label) { delete filters.label }
            if (filters.type) { delete filters.type }
            break;
          }
          case '2': {
            if (filters.value) { delete filters.value }
            if (filters.type) { delete filters.type }
            break;
          }
          case '3': {
            if (filters.value) { delete filters.value }
            if (filters.label) { delete filters.label }
            break;
          }
        }
      }
    }
  }
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/orgdict/list.vue